export default __webpack_public_path__ + "static/edroneShare-edaa7ea76b8441dc5e148c075b2946fe.png";